<template>
  <div>
    <h2>有給・書類申請</h2>
    <a href="/application/holiday">有給申請</a><br /><br /><br />
    <a href="/">領収書</a>
    <a href="/">旅費精算</a>
  </div>
</template>
